import { render } from "./CursorArrow.vue?vue&type=template&id=49d97e38&scoped=true"
import script from "./CursorArrow.vue?vue&type=script&setup=true&lang=js"
export * from "./CursorArrow.vue?vue&type=script&setup=true&lang=js"

import "./CursorArrow.vue?vue&type=style&index=0&id=49d97e38&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d97e38"],['__file',"src/scripts/common/sideBars/design/cursors/CursorArrow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49d97e38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49d97e38', __exports__)) {
    api.reload('49d97e38', __exports__)
  }
  
  module.hot.accept("./CursorArrow.vue?vue&type=template&id=49d97e38&scoped=true", () => {
    api.rerender('49d97e38', render)
  })

}


export default __exports__